import {
  Space,
  Stack,
  type Integer,
  useResponsivePropValue,
  type ValueByDevice,
} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {suffixTestId, type Nullish, type TestIdProps} from 'shared/web';

export interface SeparatorProps extends TestIdProps {
  orientation?: 'horizontal' | 'vertical' | Nullish | ValueByDevice<'horizontal' | 'vertical'>;
  spacing?: Integer | Nullish | ValueByDevice<Integer>;
}

const separatorVariants = cva('grow bg-[var(--color-general-separator)]', {
  variants: {
    isVertical: {
      true: 'h-full w-px',
      false: 'h-px w-auto',
    },
  },
});

export function Separator(props: SeparatorProps) {
  const spacing = useResponsivePropValue(props.spacing) ?? 4;
  const isVertical = useResponsivePropValue(props.orientation) === 'vertical';

  return (
    <Stack
      direction={isVertical ? 'row' : 'column'}
      width={!isVertical ? '100%' : undefined}
      data-testid={suffixTestId('separatorWrapper', props)}
    >
      <Space vertical={isVertical ? 0 : spacing} horizontal={isVertical ? spacing : 0} />
      <div aria-hidden className={cn(separatorVariants({isVertical}))} />
      <Space vertical={isVertical ? 0 : spacing} horizontal={isVertical ? spacing : 0} />
    </Stack>
  );
}
